import React from 'react';
import {Box, Grid,  Stack} from '@mui/material'; 

import FormManager from '../../../components/formComponents/FormManager';
import schema from './schema.json'; 

export default class MerchantRequest extends React.Component{

    constructor(){
        super();
        this.state={
            planlist:[{
                id:'123',
                planName:'Basic',
                planFee:'0.00',
                features:[]
            }],
            selectedPlan:'',
            previewplan:{
                id:'123',
                planName:'Basic',
                planFee:'0.00',
                features:[]
            },
            schema: schema,
            showForm: false
        }
    }

    componentDidMount(){
        var details = window.localStorage.getItem('userdetail') || ''
        if(details !== ''){
            var userdetail = JSON.parse(details);
            var schemaobj = Object.assign({}, this.state.schema);
            var properties = schemaobj.properties;
            var props = [];
            properties.forEach((field, i) => {
                if(field.name === 'merchantEmail'){
                    field.value = userdetail.email;
                    field.disabled=true
                    //console.log(field)
                }
                props.push(field);
                if(i === properties.length-1){
                    //console.log(props)
                    schemaobj.properties = props;
                    schemaobj.force = true;
                    this.setState({schema: schema, showForm: true})
                }
            });
        }
    }   

    render(){
        return <>   
            <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={1}></Grid>
                     <Grid item xs={10}>

                        <Stack spacing={3}> 
                           {this.state.showForm && <FormManager formProps={this.state.schema} />}
                        </Stack>
                    </Grid>
                    <Grid item xs={1}></Grid> 
                </Grid>
            </Box>
        </>
    }
}